import { combineReducers } from 'redux'

import deleteNode from './group/delete'
import execute from './group/execute'
import get from './group/get'
import post from './group/post'
import put from './group/put'

export default combineReducers({
  delete: deleteNode,
  execute,
  get,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/group.js